import { makeStyles } from '@material-ui/core';
import FilterIcon from 'assets/icon/filter1.svg';
import routePaths from 'constants/route-paths';
import React, { forwardRef, useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import SVG from 'react-inlinesvg';
import { useHistory } from 'react-router';
import theme from 'style/theme';

type ToggleProps = { onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void };

const CustomToggle = forwardRef<HTMLButtonElement, ToggleProps>(({ onClick }: ToggleProps, ref) => (
  <button
    id="filterButton"
    className="btn btn-icon ml-3"
    style={{
      backgroundColor: theme.colors.malibu,
      color: '#fff',
    }}
    ref={ref}
    onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    <span className="svg-icon-md">
      <SVG src={FilterIcon} />
    </span>
  </button>
));

type Props = {
  options: { value: string; text: string }[];
  onSelect: (value: string | null) => void;
  initialActive?: string;
};

const useStyles = makeStyles(() => ({
  dropdownItem: {
    '&.active, &:active': {
      backgroundColor: theme.colors.malibu + ' !important',
    },
  },
}));

const Filter = ({ options, onSelect, initialActive }: Props) => {
  const [active, setActive] = useState<string>(initialActive || options[0].value);
  const classes = useStyles();
  const history = useHistory();

  const onSelectChange = (value: string | null) => {
    if (!value) return;
    onSelect(value);
    setActive(value);
  };

  // sets the currently selected item based on the path
  useEffect(() => {
    if (!history.location.pathname) return;
    let selected = 'active';
    if (history.location.pathname.includes(routePaths.DELETED)) {
      selected = 'deleted';
    } else if (history.location.pathname.includes(routePaths.INACTIVE)) {
      selected = 'inactive';
    } else if (history.location.pathname.includes(routePaths.ABSENT)) {
      selected = 'absent';
    } else if (history.location.pathname.includes(routePaths.APPLICANT)) {
      selected = 'applicant';
    }
    // either use found option or the first available item
    const current = options.find((option) => option.value === selected) ?? options[0];
    setActive(current.value);
  }, [options, history.location.pathname]);

  return (
    <Dropdown onSelect={onSelectChange}>
      <Dropdown.Toggle as={CustomToggle}>Custom toggle</Dropdown.Toggle>
      <Dropdown.Menu>
        {options.map((option) => (
          <Dropdown.Item
            eventKey={option.value}
            key={option.value}
            active={active === option.value}
            className={classes.dropdownItem}
          >
            {option.text}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default Filter;
